export default {"src":"/_next/static/media/upload-icon.b0b114dd.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};